import type { ComponentProps } from 'react';
import { Text as RNText } from 'react-native';

import { cn } from '@/lib/design-system/cn';
import type { TextVariant } from '@/lib/design-system/tokens';
import { textVariantClass } from '@/lib/design-system/variants';

export type TextProps = ComponentProps<typeof RNText> & {
  variant?: TextVariant;
  muted?: boolean;
  subtle?: boolean;
};

export function Text({ variant = 'body', muted, subtle, className, ...props }: TextProps) {
  return (
    <RNText
      className={cn(
        textVariantClass[variant],
        muted && 'text-fg-muted',
        subtle && 'text-fg-subtle',
        className,
      )}
      {...props}
    />
  );
}
